import React from 'react'

const NotFound: React.FC = () => (
  <div>
    <h1>Page Not Found</h1>
  </div>
)

export default NotFound
